import TypeMate from 'typemate';

// import 'htmx.org';
import Carousel from './modules/carousel';
import Filter from './modules/filter';
import HeroCarousel from './modules/hero-carousel';
import Hero from './modules/hero';
import IntroOverlay from './modules/intro-overlay';
import Map from './modules/map';
import NewsCarousel from './modules/news-carousel';
import ShowMoreTable from './modules/show-more-table';
import ShowMore from './modules/show-more';
import SiteHead from './modules/site-head';
import StallionBar from './modules/stallion-bar';
import StallionCarousel from './modules/stallion-carousel';
import Tabs from './modules/tabs';
import TimelineCarousel from './modules/timeline-carousel';
import Timeline from './modules/timeline';
import ZoomedImg from './modules/zoomed-img';


/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {
                switch (module.trim()) {
                    case 'carousel':
                        let carouselInstance = new Carousel(item);
                        carouselInstance.init();
                        break;

                    case 'filter':
                        let filterInstance = new Filter(item);
                        filterInstance.init();
                        break;

                    case 'hero-carousel':
                        let heroCarouselInstance = new HeroCarousel(item);
                        heroCarouselInstance.init();
                        break;

                    case 'hero':
                        let heroInstance = new Hero(item);
                        heroInstance.init();
                        break;

                    case 'intro-overlay':
                        let introOverlayInstance = new IntroOverlay(item);
                        introOverlayInstance.init();
                        break;

                    case 'map':
                        let mapInstance = new Map(item);
                        mapInstance.init();
                        break;

                    case 'news-carousel':
                        let newsCarouselInstance = new NewsCarousel(item);
                        newsCarouselInstance.init();
                        break;

                    case 'site-head':
                        let siteHeadInstance = new SiteHead(item);
                        siteHeadInstance.init();
                        break;

                    case 'show-more-table':
                        let showMoreTableInstance = new ShowMoreTable(item);
                        showMoreTableInstance.init();
                        break;

                    case 'show-more':
                        let showMoreInstance = new ShowMore(item);
                        showMoreInstance.init();
                        break;

                    case 'stallion-bar':
                        let stallionBarInstance = new StallionBar(item);
                        stallionBarInstance.init();
                        break;

                    case 'stallion-carousel':
                        let stallionCarouselInstance = new StallionCarousel(item);
                        stallionCarouselInstance.init();
                        break;

                    case 'tabs':
                        let tabsInstance = new Tabs(item);
                        tabsInstance.init();
                        break;

                    case 'timeline-carousel':
                        let timelineCarouselInstance = new TimelineCarousel(item);
                        timelineCarouselInstance.init();
                        break;

                    case 'timeline':
                        let timelineInstance = new Timeline(item);
                        timelineInstance.init();
                        break;

                    case 'zoomed-img':
                        let zoomedImageInstance = new ZoomedImg(item);
                        zoomedImageInstance.init();
                        break;
                }
            });
        });
    },

    alwaysLoad() {
        const typemateContext = document.querySelector('main');
        const typeMateInstance = new TypeMate(typemateContext, {
            selector: 'p, h1, h2, h3, h4, h5, h6'
        });
        typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
